import { useEffect, useRef } from 'react';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { useFlags } from '../../../contexts/LDContext';

import {
  anonymizeFullStoryUser,
  formatFullStoryUserProperties,
  identifyFullStoryUser,
  initializeFullStory,
} from './FullStory.service';

export const useFullStory = () => {
  const rideiqFlags = useFlags();
  const { fullStoryEnabled } = rideiqFlags;
  const { user } = useAuthQuery();
  const activeFeatureFlagsRef = useRef(rideiqFlags);

  activeFeatureFlagsRef.current = rideiqFlags;

  const hasInitialized = useRef(false);
  const identifiedSlugRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (fullStoryEnabled && window.env.RIDEIQ_FULLSTORY_ORG_ID && !hasInitialized.current) {
      const devMode = window.env.RIDEIQ_ENVIRONMENT === 'local';

      initializeFullStory(window.env.RIDEIQ_FULLSTORY_ORG_ID, devMode);
      hasInitialized.current = true;
    }
  }, [fullStoryEnabled]);

  useEffect(() => {
    if (!fullStoryEnabled || !window.env.RIDEIQ_FULLSTORY_ORG_ID) {
      return;
    }

    if (user && user.slug !== identifiedSlugRef.current) {
      identifiedSlugRef.current = user.slug;
      identifyFullStoryUser(user.slug, formatFullStoryUserProperties(user, activeFeatureFlagsRef.current));
    } else if (!user && identifiedSlugRef.current) {
      identifiedSlugRef.current = undefined;
      anonymizeFullStoryUser();
    }
  }, [fullStoryEnabled, user]);
};
